module.exports = __webpack_public_path__ + "img/algo_logo.fd20e163.svg";